import { render } from "./HeroSectionTitle.vue?vue&type=template&id=ed5d67e2"
import script from "./HeroSectionTitle.vue?vue&type=script&lang=js"
export * from "./HeroSectionTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__